<template>
  <v-main>
    <!-- TOP IMAGE -->
    <v-container
      class="col-10 pa-0 ma-0-auto mt-4 d-flex flex-column flex-lg-row page-wrapper mb-16"
    >
      <div class="col-12 pa-0 ">
        <v-img
          src="@/assets/images/entrypages/8_Nova_SBE_Picture3.jpg"
          height="250"
        >
          <div style="margin-top: 30px; margin-left: 30px;">
            <h4 class="page-title">
              <span
                style="background-color: white ; opacity: 0.9; padding: 10px;"
              >
                {{ $t(menu).content.title }}</span
              >
            </h4>
          </div>
        </v-img>
      </div>
    </v-container>

    <v-container
      class="col-10 pa-0 ma-0-auto d-flex flex-column flex-lg-row page-wrapper"
    >
      <div class="col-12 col-lg-3 pa-0 page-sidebar">
        <SideMenu
          class="d-none d-lg-block"
          page="/about/"
          :menu="menu"
          @menuContent="passMenuContent"
        ></SideMenu>
      </div>

      <div class="col-12 col-lg-9 pa-0 pl-lg-12 page-content">
        <Ecosystem
          v-if="this.$route.params.slug === 'ecosystem'"
          :content="content"
        />
        <Team
          v-else-if="this.$route.params.slug === 'team'"
          :content="content"
        />
        <Figures
          v-else-if="this.$route.params.slug === 'figures'"
          :content="content"
        />
        <Contacts
          v-else-if="this.$route.params.slug === 'contacts'"
          :content="content"
        />
        <Stories
          v-else-if="this.$route.params.slug === 'stories'"
          :content="content"
        />
        <div v-else-if="this.$route.fullPath.endsWith('about')">
          <Home :content="$t(menu).content" />
          <div>
            <SideMenu
              class="d-lg-none mt-10"
              page="/about/"
              :menu="menu"
              @menuContent="passMenuContent"
            ></SideMenu>
          </div>
        </div>
        <NotFound v-else :menu="menu" />
      </div>
    </v-container>
  </v-main>
</template>

<script>
import SideMenu from '@/components/SideMenu'
import Home from './About/Home'
import Ecosystem from './About/Ecosystem'
import Team from './About/Team'
import Figures from './About/Figures'
import Contacts from './About/Contacts'
import Stories from './About/Stories'
import NotFound from './NotFound'

export default {
  name: 'About',
  components: {
    SideMenu,
    Home,
    Ecosystem,
    Team,
    Figures,
    Contacts,
    Stories,
    NotFound,
  },
  data() {
    return {
      search: null,
      caseSensitive: false,
      menu: 'SideMenuAbout',
      content: {},
    }
  },
  computed: {},
  methods: {
    passMenuContent(content) {
      this.content = content
    },
  },
}
</script>

<style lang="scss">
.page-img-title {
  margin-top: 130px;
  margin-left: 30px;
}

.about-page {
  h2 {
    @extend .content-title;
  }

  ul,
  .about-stories-body {
    @extend .content-body;
  }
}

.page-title {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    font-size: 20px !important;
  }
}
</style>
